import {GlobalClientStateDefinition} from './makeUseGlobalClientState';

export enum GlobalClientStateActionTypes {
  GLOBAL_CLIENT_STATE_UPDATE = 'GLOBAL_CLIENT_STATE_UPDATE',
}

export interface GlobalClientStateUpdateAction<TStateType> {
  type: GlobalClientStateActionTypes.GLOBAL_CLIENT_STATE_UPDATE;
  newState: TStateType;
  stateDefinition: GlobalClientStateDefinition<TStateType>;
  stateId: string;
}

export function updateGlobalClientState<TStateType>(
  stateDefinition: GlobalClientStateDefinition<TStateType>,
  stateId: string,
  newState: TStateType
): GlobalClientStateUpdateAction<TStateType> {
  return {
    type: GlobalClientStateActionTypes.GLOBAL_CLIENT_STATE_UPDATE,
    newState,
    stateDefinition,
    stateId,
  };
}

export type GlobalClientStateAction = GlobalClientStateUpdateAction<unknown>;
